import React from 'react';
import * as Css from './styles';

const UfoAnimation = () => {
  return (
    <Css.Wrap>
      <Css.UFO1 />
      <Css.UFO2 />
      <Css.UFO3 />
    </Css.Wrap>
  );
};

export default UfoAnimation;
